import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { DocsSidebarComponent } from '@shared/components/docs-sidebar/docs-sidebar';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { lucidePanelLeft } from '@ng-icons/lucide';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmLeadDirective } from '@spartan-ng/helm/typography';
import { HlmSeparatorDirective } from '@spartan-ng/helm/separator';
import { BrnSeparatorComponent } from '@spartan-ng/brain/separator';
import { SidebarService } from '@shared/services/sidebar.service';
import { HlmButtonDirective } from '@spartan-ng/helm/button';

@Component({
  selector: 'app-docs-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    DocsSidebarComponent,
    NgIconComponent,
    ...HlmCardImports,
    HlmSeparatorDirective,
    BrnSeparatorComponent,
    HlmButtonDirective,
    HlmLeadDirective,
  ],
  providers: [
    provideIcons({
      lucidePanelLeft,
    }),
  ],
  templateUrl: './docs-layout.html',
  styleUrl: './docs-layout.css',
  host: {
    class: 'block',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocsLayout {
  readonly sidebarService = inject(SidebarService);

  pageTitle() {
    return 'Dokumentation';
  }

  toggleSidebar(): void {
    this.sidebarService.toggleSidebar();
  }
}
